"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationTelemetry = void 0;
const api_1 = require("@opentelemetry/api");
const shared_1 = require("./shared");
class OperationTelemetry {
    constructor(operationName) {
        this.operationName = operationName;
        this.tracer = api_1.trace.getTracer('operation-telemetry');
    }
    // Start a new span using the operation context
    // if there is no parent span, then this is a root span
    startSpan(spanName, ctx) {
        const curCtx = getContextWithOperationNameBaggage(this.operationName, ctx ?? api_1.context.active());
        const parentSpan = api_1.trace.getSpan(curCtx);
        const span = this.tracer.startSpan(spanName, {}, curCtx);
        span.setAttribute('operation.name', this.operationName);
        if (!parentSpan) {
            span.setAttribute('operation.is_root', true);
        }
        return span;
    }
    // Start a new root active span detaching from the current context
    // It will return whatever fn returns
    startRootActiveSpan(spanName, fn) {
        return this.tracer.startActiveSpan(spanName, {}, getContextWithOperationNameBaggage(this.operationName, api_1.ROOT_CONTEXT), (span) => {
            span.setAttribute('operation.name', this.operationName);
            span.setAttribute('operation.is_root', true);
            return fn(span);
        });
    }
    // Start an active span using current context
    // if there is no parent span, then this is a root span
    // It will return whatever fn returns
    startActiveSpan(spanName, fn) {
        const ctx = getContextWithOperationNameBaggage(this.operationName, api_1.context.active());
        const parentSpan = api_1.trace.getSpan(ctx);
        return this.tracer.startActiveSpan(spanName, {}, ctx, (span) => {
            span.setAttribute('operation.name', this.operationName);
            if (!parentSpan) {
                span.setAttribute('operation.is_root', true);
            }
            return fn(span);
        });
    }
    setErrorStatus(span, errorMessage) {
        (0, shared_1.recordSpanError)(span, new Error(errorMessage));
    }
    setOkStatus(span) {
        span.setStatus({ code: api_1.SpanStatusCode.OK });
    }
}
exports.OperationTelemetry = OperationTelemetry;
function operationBaggageExists(operationName) {
    let baggage = api_1.propagation.getBaggage(api_1.context.active());
    if (!baggage) {
        return false;
    }
    let baggageValue = baggage.getEntry('operation.name');
    return !!baggageValue && baggageValue.value === operationName;
}
function getContextWithOperationNameBaggage(operationName, curContext) {
    if (operationBaggageExists(operationName)) {
        return curContext;
    }
    let curBaggage = api_1.propagation.getBaggage(curContext) ?? api_1.propagation.createBaggage();
    let newBaggage = curBaggage.setEntry('operation.name', {
        value: operationName,
    });
    // context is immutable, so we need to create a new one with the new baggage
    // each context is a trace
    return api_1.propagation.setBaggage(curContext, newBaggage);
}
